import "./DesktopSelfServe.css";
import { useLang } from "../../../../i18n/LangContext";
// import placeholderVisual from "../../../../assets/desktopAdvertise/selfServe/self-serve.png";
import HeroAnimation from "../hero/HeroAnimation";

export default function DesktopSelfServe({ id = "about" }) {
  const { t } = useLang();
  const data = t?.advertiseSelfServe;
  if (!data) return null;

  return (
    <section id={id} className="selfserve-root selfserve-desktop" aria-label="Self-serve platform">
      <div className="selfserve-wrap">
        <div className="selfserve-left">
          <HeroAnimation></HeroAnimation>
        </div>

        <div className="selfserve-right">
          <p className="selfserve-eyebrow">{data.eyebrow}</p>
          <h2 className="selfserve-title">
            {data.titleLine1}<br />{data.titleLine2}
          </h2>
          <p className="selfserve-desc">{data.desc}</p>
          <button className="selfserve-cta">
            <span className="selfserve-cta-inner">{data.cta.toUpperCase()}</span>
          </button>
        </div>
      </div>
    </section>
  );
}
